import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import { LatexQuestionDiv } from "../Components/LatexQuestionDiv";

export const ViewFullPaper = () => {
  const [tab, setTab] = useState(0);

  const col = [""];

  let location = useLocation();
  let { qp } = location.state;
  return (
    <>
      <div className="flex flex-row space-x-8 bg-gray-100">
        {tab === 0 ? (
          <button className="text-2xl mb-2 bg-[#FFACAC] mx-2 p-2 rounded-lg">
            All
          </button>
        ) : (
          <button
            onClick={() => setTab(0)}
            className="text-2xl mb-2 bg-slate-200 mx-2 p-2 rounded-lg"
          >
            All
          </button>
        )}
        {tab === 1 ? (
          <button className="text-2xl mb-2 bg-[#FFACAC] mx-2 p-2 rounded-lg">
            Physics
          </button>
        ) : (
          <button
            onClick={() => setTab(1)}
            className="text-2xl mb-2 bg-slate-200 mx-2 p-2 rounded-lg"
          >
            Physics
          </button>
        )}
        {tab === 2 ? (
          <button
            onClick={() => setTab(2)}
            className="text-2xl mb-2 bg-[#FFACAC] mx-2 p-2 rounded-lg"
          >
            Chemistry
          </button>
        ) : (
          <button
            onClick={() => setTab(2)}
            className="text-2xl mb-2 bg-slate-200 mx-2 p-2 rounded-lg"
          >
            Chemistry
          </button>
        )}
        {tab === 3 ? (
          <button
            onClick={() => setTab(3)}
            className="text-2xl mb-2 bg-[#FFACAC] mx-2 p-2 rounded-lg"
          >
            Biology
          </button>
        ) : (
          <button
            onClick={() => setTab(3)}
            className="text-2xl mb-2 bg-slate-200 mx-2 p-2 rounded-lg"
          >
            Biology
          </button>
        )}
      </div>
      {(tab === 0 || tab === 1) && (
        <>
          <div className="p-3 text-lg font-medium text-center bg-green-200 my-2">
            Physics
          </div>
          {qp.phy.map((q, idx) => {
            return (
              <>
                <div className="flex flex-row">
                  <div className="p-2 bg-pink-200 mb-4 rounded-sm text-xl font-bold">
                    {idx + 1}
                  </div>
                  <div className="bg-[#FBFFB1] p-2 w-full mb-4">
                    <LatexQuestionDiv q={q} />
                  </div>
                </div>
              </>
            );
          })}
        </>
      )}

      {(tab === 0 || tab === 2) && (
        <>
          <div className="p-3 text-lg font-medium text-center bg-green-200 my-2">
            Chemistry
          </div>

          {qp.chem.map((q) => {
            return (
              <>
                <LatexQuestionDiv q={q} />
              </>
            );
          })}
        </>
      )}

      {(tab === 0 || tab === 3) && (
        <>
          <div className="p-3 text-lg font-medium text-center bg-green-200 my-2">
            Biology
          </div>

          {qp.bio.map((q) => {
            return (
              <>
                <LatexQuestionDiv q={q} />
              </>
            );
          })}
        </>
      )}
    </>
  );
};
